<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Internal Notes</h5>
            </b-col>
        </b-row>

        <b-form-tags v-model="noteTags"
                     size="sm"
                     placeholder=""
                     separator=","
                     no-outer-focus>
            <template v-slot="{ tags, inputAttrs, inputHandlers, removeTag }">
                <b-input-group aria-controls="my-custom-tags-list" size="sm">
                    <input
                            v-bind="inputAttrs"
                            v-on="inputHandlers"
                            placeholder="Enter to add"
                            class="form-control">
                </b-input-group>

                <ul class="list-unstyled d-inline-flex flex-wrap mb-0">
                    <b-card v-for="tag in tags" :key="tag" size="sm"
                            class="mt-1 mr-1"
                            body-class="py-0 pr-2">
                        <drag :transfer-data="tag" drop-effect="copy" effect-allowed="copy">
                            <span>{{ tag }}</span>

                            <b-button variant="link" class="pt-1 pb-1 text-secondary" @click="removeTag(tag)" tabindex="-1">
                                <b-icon-x-square></b-icon-x-square>
                            </b-button>
                        </drag>
                    </b-card>
                </ul>

            </template>
        </b-form-tags>
    </div>
</template>

<script>
    import arrayMixin from "../../mixins/array";
    import genreList from "../../assets/genreList";

    export default {
        name: "InternalNotes",
        props: [ 'notes' ],
        mixins: [ arrayMixin, genreList ],
        created() {
            this.clone(this.notes);
            this.noteTags = this.filteredNotes;
        },
        data() {
            return {
                noteTags: [],
            }
        },
        computed: {
            filteredNotes() {
                return this.component.filter(note => note.type === 'internal')
                    .map(note => note.text);
            }
        },
        watch: {
            noteTags(newValue, oldValue) {
                if (newValue.length !== oldValue.length && newValue !== this.filteredNotes) {
                    let prepared = newValue.map(note => {
                        return { text: note, type: 'internal' };
                    });

                    this.$emit('updateInternalNotes', prepared);
                }
            }
        }
    }
</script>

<style scoped>
</style>